import { recordToKeyValueMap } from '../../../common/keyValueMap'
import { deepMerge } from '../../../utils/deepMerge'
import { type Move } from './models/move.model'

import { useMoveEstimatedRequirements } from './moves.hooks'
import { type MoveRequest } from './moves.types'

type DeepPartial<T> = T extends object ? {
  [P in keyof T]?: DeepPartial<T[P]>;
} : T

export const useGetMoveRequestPayload = () => {
  const getMoveEstimatedRequirements = useMoveEstimatedRequirements()

  return (move: Move, moveRequest: DeepPartial<MoveRequest>): MoveRequest => {
    const updatedMove = structuredClone({
      ...move,
      request: deepMerge(move.request, moveRequest as any),
    })

    if ('residenceRoomsPrefilled' in updatedMove.request.residence) {
      delete updatedMove.request.residence.residenceRoomsPrefilled
    }
    if ('specialItemsPrefilled' in updatedMove.request.content) {
      delete updatedMove.request.content.specialItemsPrefilled
    }

    updatedMove.request.content.nbBoxes ??= 0
    updatedMove.request.content.furnitureRatio ??= 0

    const newEstimateRequirements = getMoveEstimatedRequirements(updatedMove)

    return {
      ...updatedMove.request,
      size: {
        volumeCubicFeet: newEstimateRequirements.volumeCubicFeet,
        weightPounds: newEstimateRequirements.weightPounds,
      },
      requirements: {
        nbMen: newEstimateRequirements.nbMen,
        nbTrucks: recordToKeyValueMap(newEstimateRequirements.nbTrucks),
        movingLabourTime: newEstimateRequirements.estimatedMovingLabourTime,
        packingLabourTime: newEstimateRequirements.estimatedPackingLabourTime,
      },
    }
  }
}
